// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-2mxwiCZ6QYulURMZ3BB-V1"};